import { render, staticRenderFns } from "./ArchivedAmendTenders.vue?vue&type=template&id=75b73718&scoped=true&"
import script from "./ArchivedAmendTenders.vue?vue&type=script&lang=js&"
export * from "./ArchivedAmendTenders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b73718",
  null
  
)

export default component.exports